import { jsx as _jsx } from "react/jsx-runtime";
import { GoogleChartWrapper } from './GoogleChartWrapper';
const debug = process.env.REACT_APP_DEBUG && false;
export const LineBarChart = ({ data, options, fragmentProps }) => {
    const chartClass = google.visualization.ComboChart;
    return _jsx(GoogleChartWrapper, { data: data, options: options, fragmentProps: fragmentProps, chartClass: chartClass });
};
